(() => {
  "use strict";

  let urlToPreload;
  let mouseoverTimer;
  let lastTouchTimestamp = 0;
  const prefetcher = document.createElement("link");
  const connection = navigator.connection || {};
  const isSupported = !!(prefetcher.relList && prefetcher.relList.supports && prefetcher.relList.supports("prefetch"));
  const allowQueryString = "instantAllowQueryString" in document.body.dataset;
  const allowExternalLinks = "instantAllowExternalLinks" in document.body.dataset;

  if (!isSupported || connection.saveData) return;

  prefetcher.rel = "prefetch";
  document.head.appendChild(prefetcher);

  document.addEventListener("touchstart", touchstartListener, { capture: true, passive: true });
  document.addEventListener("mouseover", mouseoverListener, { capture: true, passive: true });

  function touchstartListener(event) {
    lastTouchTimestamp = performance.now();
    const link = event.target.closest("a");
    if (!isPreloadable(link)) return;
    link.addEventListener("touchcancel", touchendAndTouchcancelListener, { passive: true });
    link.addEventListener("touchend", touchendAndTouchcancelListener, { passive: true });
    urlToPreload = link.href;
    preload(link.href);
  }

  function touchendAndTouchcancelListener() {
    urlToPreload = undefined;
    stopPreloading();
  }

  function mouseoverListener(event) {
    if (performance.now() - lastTouchTimestamp < 1100) return;
    const link = event.target.closest("a");
    if (!isPreloadable(link)) return;
    link.addEventListener("mouseout", mouseoutListener, { passive: true });
    urlToPreload = link.href;
    mouseoverTimer = setTimeout(() => {
      preload(link.href);
      mouseoverTimer = undefined;
    }, 65);
  }

  function mouseoutListener(event) {
    if (event.relatedTarget && event.target.closest("a") === event.relatedTarget.closest("a")) return;
    if (mouseoverTimer) {
      clearTimeout(mouseoverTimer);
      mouseoverTimer = undefined;
      return;
    }
    urlToPreload = undefined;
    stopPreloading();
  }

  function isPreloadable(link) {
    if (!link || !link.href || urlToPreload === link.href) return false;
    const url = new URL(link.href);
    if (!allowExternalLinks && url.origin !== location.origin && !("instant" in link.dataset)) return false;
    if (!["http:", "https:"].includes(url.protocol)) return false;
    if (url.protocol === "http:" && location.protocol === "https:") return false;
    if (!allowQueryString && url.search && !("instant" in link.dataset)) return false;
    if (url.hash && url.pathname + url.search === location.pathname + location.search) return false;
    return !("noInstant" in link.dataset);
  }

  function preload(url) {
    prefetcher.href = url;
  }

  function stopPreloading() {
    prefetcher.removeAttribute("href");
  }
})();

(() => {
  "use strict";

  try {
    if (/^\/(?:cart|checkout)(?:\/|$)/.test(window.location.pathname)) return;

    const loaderVersion = "2026052903";
    const fallbackAssetBase = "https://www.cloud9smokeco.com/cdn/shop/t/28/assets/";
    const currentScriptSrc = document.currentScript && document.currentScript.src;
    const assetBase = currentScriptSrc
      ? currentScriptSrc.replace(/tiny-img-link-preloader\.js(?:\?.*)?$/, "")
      : fallbackAssetBase;
    const loaderSrc = assetBase + "cloud9-concierge-loader.js?v=" + loaderVersion;
    const isFullWidgetScript = (node) =>
      node &&
      node.tagName === "SCRIPT" &&
      /cloud9-concierge\.js/.test(node.src || "") &&
      !/cloud9-concierge-loader/.test(node.src || "");
    const isOutdatedLoaderScript = (node) =>
      node &&
      node.tagName === "SCRIPT" &&
      /cloud9-concierge-loader\.js/.test(node.src || "") &&
      !new RegExp("[?&]v=" + loaderVersion + "(?:&|$)").test(node.src || "");

    function hasLoader() {
      return !!document.querySelector('script[src*="cloud9-concierge-loader.js"][src*="v=' + loaderVersion + '"]');
    }

    function hasWidget() {
      return !!(window.Cloud9ConciergeLoaded || document.getElementById("cloud9-concierge"));
    }

    function ageGateVisible() {
      const gate = document.getElementById("age-verification");
      if (!gate) return false;
      const style = window.getComputedStyle(gate);
      const rect = gate.getBoundingClientRect();
      return style.display !== "none" && style.visibility !== "hidden" && style.opacity !== "0" && rect.width > 0 && rect.height > 0;
    }

    function waitForAgeGate(callback) {
      if (window.Cloud9ConciergeAgeGatePreloadWait) return;
      window.Cloud9ConciergeAgeGatePreloadWait = true;
      let observer;
      const tryStart = () => {
        if (ageGateVisible()) return;
        if (observer) observer.disconnect();
        window.Cloud9ConciergeAgeGatePreloadWait = false;
        callback();
      };
      observer = new MutationObserver(tryStart);
      observer.observe(document.documentElement, { attributes: true, childList: true, subtree: true });
      window.setTimeout(tryStart, 250);
    }

    function installLoader() {
      if (hasLoader() || hasWidget()) return;
      if (ageGateVisible()) {
        waitForAgeGate(installLoader);
        return;
      }
      const script = document.createElement("script");
      script.src = loaderSrc;
      script.defer = true;
      script.setAttribute("data-cloud9-loader", "2026-05-29-learning");
      document.head.appendChild(script);
    }

    function neutralizeOutdatedScript(node) {
      if (!isFullWidgetScript(node) && !isOutdatedLoaderScript(node)) return;
      node.type = "text/plain";
      node.remove();
      installLoader();
    }

    document
      .querySelectorAll('script[src*="cloud9-concierge.js"],script[src*="cloud9-concierge-loader.js"]')
      .forEach(neutralizeOutdatedScript);

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", installLoader, { once: true });
    } else {
      installLoader();
    }

    new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes && record.addedNodes.forEach(neutralizeOutdatedScript);
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (error) {}
})();
